import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function FireSafety({
  getFireSafetyList,
  fireSafetyList,
  getFireSafetyCalculation,
  fireSafetyCalculation,
  newOtherFeesId,
  updateCalculationFireSafety,
}) {
  const [fireSafetyListFormat, setfireSafetyListFormat] = useState([]);
  const [
    fireSafetyCalculationFormat,
    setFireSafetyCalculationFormat,
  ] = useState([]);
  // const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);

  useEffect(() => {
    getFireSafetyList();
    getFireSafetyCalculation(newOtherFeesId);
  }, []);

  // const handleSetMode = num => {
  //   setMode(num);
  // };

  // const handleCancel = () => {
  //   setFormData(fireSafetyCalculationFormat);
  //   handleSetMode(0);
  // };

  useEffect(() => {
    if (!_.isEmpty(fireSafetyList)) {
      const list = fireSafetyList.map(x => ({
        code: _.get(x, 'code', ''),
        description: _.get(x, 'description'),
      }));
      setfireSafetyListFormat(list);
    }
  }, [fireSafetyList]);

  const formatFormData = () => {
    if (!_.isEmpty(fireSafetyCalculation)) {
      const list = fireSafetyCalculation.map(x => ({
        is_exempted: _.get(x, 'attributes.is_exempted'),
        code: _.get(x, 'attributes.code'),
      }));
      setFireSafetyCalculationFormat(list);
      setFormData(list);
    }
  };

  useEffect(() => {
    formatFormData();
  }, [fireSafetyCalculation]);

  const handleSubmit = (calculationId) => {
    // handleSetMode(0);
    const fireList =
      fireSafetyCalculationFormat.find(
        data =>
          data.code === calculationId
      ) || [];

    const finalList = formData.find(x => x.code === fireList.code)

    const list = [finalList.code];

    const args = {
      code: list,
    };

    updateCalculationFireSafety(newOtherFeesId, args, () => {
      getFireSafetyList();
      getFireSafetyCalculation(newOtherFeesId);
    });
  };

  const handleToggle = (calculationId) => () => {

    // handleSetMode(1);
    const item =
      formData.find(
        data =>
          +data.code === +calculationId && data.is_exempted === 1
      ) || {};


    if (_.isEmpty(item)) {
      setFormData(
        _.concat(formData, {
          is_exempted: 1,
          code: calculationId,
        })
      );
      handleSubmit(calculationId);
      return true;
    }

    if (!_.isEmpty(item)) {
      setFormData(_.reject(formData, item));
      handleSubmit(calculationId);
      return true;
    }
    return '';
  };

  const renderCheckbox = (calculationId, is_exempted) => {
    const item =
      formData.filter(
        data =>
          +data.code === +calculationId && data.is_exempted === is_exempted
      ) || {};

    return (
      <button
        type="button"
        is_exempted="button"
        className="btn-blank"
        onClick={handleToggle(calculationId, is_exempted)}
      >
        {_.isEmpty(item) ? (
          <i className="far fa-square icon-check-box" />
        ) : (
          <i className="fas fa-check-square icon-box" />
        )}
      </button>
    );
  };

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center">
            <div className="col-6">
              <h3>Fire Safety Calculation</h3>
            </div>
            {/* <div className="col-6 d-flex">
              {mode === 1 ? (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold ml-auto px-4 mr-2"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-round font-weight-bold px-4"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : (
                ''
              )}
            </div> */}
          </div>
          <div className="table-responsive mt-2">
            <table className="table table-borderless">
              <thead>
                <tr>
                  {!_.isEmpty(fireSafetyCalculation) ? (
                    <React.Fragment>
                      <th scope="col" className="px-1">
                        Fire Safety Inspection Fees
                      </th>
                      <th scope="col" className="px-1">
                        <div className="w-100 text-center">Exempted</div>
                      </th>
                    </React.Fragment>
                  ) : (
                    <th scope="col">Fire Safety Inspection Types</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(fireSafetyListFormat) ? (
                  <React.Fragment>
                    {fireSafetyListFormat.map(item => (
                      <tr className="top-border" key={item.code}>
                        <td className="font-weight-bold py-3">
                          {item.description}
                        </td>
                        <td className="py-3">
                          <div className="w-100 text-center">
                            {renderCheckbox(_.get(item, 'code'), 1)}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ) : (
                  <tr />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

FireSafety.propTypes = {
  getFireSafetyList: PropTypes.instanceOf(Function).isRequired,
  fireSafetyList: PropTypes.instanceOf(Object).isRequired,
  getFireSafetyCalculation: PropTypes.instanceOf(Function).isRequired,
  fireSafetyCalculation: PropTypes.instanceOf(Array).isRequired,
  updateCalculationFireSafety: PropTypes.instanceOf(Function).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  fireSafetyList: _.get(api, `${c.GET_FIRE_SAFETY_LIST}.res.fees`) || [],
  fireSafetyCalculation:
    _.get(api, `${c.GET_FIRE_SAFETY_CALCULATION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FireSafety);
